// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2594":"3d218056","4632":"9e962f7a","5982":"a7c9bf36","7204":"9e962f7a","8263":"6c51734b","8688":"b3249b30"}[chunkId] + ".chunk.css";
};